import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import EmailTemplate from "./EmailTemplate";
import MuiTable from "../MuiTable/MuiTable";
import { httpRequest, onRequestError, printLog } from "../../helper/global";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { set } from "date-fns";

export default function EmailTemplateHome({ theme, user, permissionConfig }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openTemplate, setOpenTemplate] = useState(false);
    const [emailTemplates, setEmailTemplates] = useState([]);
    const [initialTemplateId, setInitialTemplateId] = useState(null);
    const [initialTitle, setInitialTitle] = useState("");
    const [initialContent, setInitialContent] = useState("");

    const columns = [
        {
            id: "title",
            label: "Title",
            sort: true,
            visible: true,
        },

        {
            id: "updatedAt",
            label: "Last Updated",
            sort: true,
            visible: true,
        },

        {
            id: "allowDelete",
            label: "Allow Delete",
            sort: true,
            visible: true,
            formatter: (value, row, index) => {
                return value ? "Yes" : "No";
            },
        },
    ];

    const handleTemplateResults = (result) => {
        if (result === false) {
            return;
        }

        setEmailTemplates(result);
    };

    const fetchEmailTemplates = async () => {
        try {
            const result = await httpRequest(
                `email/list`,
                {},
                "GET",
                (error) => {
                    onRequestError(dispatch, navigate, {
                        title: error.title,
                        message: error.message,
                    });
                }
            );

            if (result === false) {
                return;
            }

            handleTemplateResults(result.payload);
        } catch (error) {
            console.error("Error fetching email templates:", error);
        }
    };

    useEffect(() => {
        fetchEmailTemplates();
    }, []);

    return (
        <>
            <Box sx={{ p: 3 }}>
                {!openTemplate && (
                    <Box>
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setOpenTemplate(true);
                                setInitialTemplateId(null);
                                setInitialTitle("New Template");
                                setInitialContent(``);
                            }}
                        >
                            New Template
                        </Button>
                        <Box sx={{ mt: 3 }}>
                            <MuiTable
                                allowSearch={false}
                                theme={theme}
                                id={"templateId"}
                                headCells={columns}
                                defaultData={emailTemplates}
                                rowsPerPageArray={[50, 100, 200]}
                                onSelectRow={(row) => {
                                    setOpenTemplate(true);
                                    setInitialTemplateId(row.templateId);
                                    setInitialTitle(row.title);
                                    setInitialContent(row.content);
                                }}
                            />
                        </Box>
                    </Box>
                )}

                {openTemplate && (
                    <EmailTemplate
                        theme={theme}
                        isOpen={openTemplate}
                        onClose={() => setOpenTemplate(false)}
                        initialTitle={initialTitle}
                        initialTemplateId={initialTemplateId}
                        initialContent={initialContent}
                        updateTempleteResults={handleTemplateResults}
                    />
                )}
            </Box>
        </>
    );
}
